const compatModules = {};import * as Mod1 from "./discourse/controllers/siwe-auth-index";
compatModules["discourse/controllers/siwe-auth-index"] = Mod1;

export * as discourse$controllers$siwe__auth__index$$__module from "./discourse/controllers/siwe-auth-index";
export {
default as discourse$controllers$siwe__auth__index$$default
} from "./discourse/controllers/siwe-auth-index";
import * as Mod2 from "./discourse/routes/siwe-auth-index";
compatModules["discourse/routes/siwe-auth-index"] = Mod2;

export * as discourse$routes$siwe__auth__index$$__module from "./discourse/routes/siwe-auth-index";
export {
default as discourse$routes$siwe__auth__index$$default
} from "./discourse/routes/siwe-auth-index";
import * as Mod3 from "./discourse/siwe-route-map";
compatModules["discourse/siwe-route-map"] = Mod3;

export * as discourse$siwe__route__map$$__module from "./discourse/siwe-route-map";
export {
default as discourse$siwe__route__map$$default
} from "./discourse/siwe-route-map";
import * as Mod4 from "./discourse/templates/siwe-auth-index";
compatModules["discourse/templates/siwe-auth-index"] = Mod4;

export * as discourse$templates$siwe__auth__index$$__module from "./discourse/templates/siwe-auth-index";
export {
default as discourse$templates$siwe__auth__index$$default
} from "./discourse/templates/siwe-auth-index";
export default compatModules;
